import { useQuery } from '@tanstack/react-query';
import { BaseApi } from '../api/apiBase';

interface ParticipantCheckResponse {
  id: string | null;
  isParticipant: boolean;
  isV1Event: boolean;
}

class ParticipantCheckApi extends BaseApi {
  async checkParticipant(eventSlug: string): Promise<ParticipantCheckResponse> {
    // Use the portal API endpoint - it allows unauthenticated access
    return this.get<ParticipantCheckResponse>(`/events/${eventSlug}/participant_check`);
  }
}

const participantCheckApi = new ParticipantCheckApi();

export const useParticipantCheck = (eventSlug: string, enabled = true) => {
  const result = useQuery({
    queryKey: ['participant-check', eventSlug],
    queryFn: async () => {
      console.log('[useParticipantCheck] Checking participant status for event:', eventSlug);
      const response = await participantCheckApi.checkParticipant(eventSlug);
      console.log('[useParticipantCheck] Response:', response);
      return response;
    },
    enabled: enabled && !!eventSlug,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: false, // Don't retry on 401
  });

  console.log('[useParticipantCheck] Query result:', {
    data: result.data,
    isLoading: result.isLoading,
    isError: result.isError,
    error: result.error,
    enabled: enabled && !!eventSlug
  });

  return result;
};